import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { Map, List, fromJS, OrderedMap } from 'immutable';
import Actions from 'flow/actions';
import { listToMap, keyIn } from 'flow/utils';
import { getVoiceMessagesSortedByReceivedDate } from 'flow/utils/call-records-utils';
var initialState = Map({
  waitingQueueItems: Map({
    byKey: Map(),
    byQueue: Map()
  }),
  queueMembers: Map()
});

// eslint-disable-next-line complexity
export var pbxReducer = function pbxReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action ? action.type : null) {
    case Actions.CLEAR_STATE:
      {
        return initialState;
      }
    case Actions.RESULT_QUEUE:
      {
        var queueDTO = fromJS(action.data);
        var reducedQueueDTO = queueDTO["delete"]('queueCalls')["delete"]('queueMembers');
        var queueMembers = queueDTO.get('queueMembers');
        return state.updateIn(['queues', action.key], Map(), function (prev) {
          return prev["delete"]('welcomeSound')["delete"]('activeProfile')["delete"]('queueWaves').mergeDeep(reducedQueueDTO);
        }).update('queueMembers', function () {
          var prevQueueMembers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
          if (queueMembers) {
            return prevQueueMembers.set(action.key, queueMembers);
          }
          return prevQueueMembers;
        }).update('sortingData', function () {
          var sortingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
          // The PBX list searches this projection, which RESULT_QUEUES builds.
          // A single queue arrives here after a save or a fetch, so its keywords
          // are refreshed when it carries its own contact; a queue the list has
          // not projected yet is left for RESULT_QUEUES to add. (AC-1943)
          if (!queueDTO.has('contact') || !sortingData.hasIn(['queues', action.key])) {
            return sortingData;
          }
          return sortingData.setIn(['queues', action.key, 'keywords'], queueDTO.getIn(['contact', 'keywords']));
        });
      }
    case Actions.RESULT_TOP_WAITING_QUEUE_ITEMS_ADD:
      {
        var byKeyMap = state.getIn(['waitingQueueItems', 'byKey'], Map());
        var byQueueList = state.getIn(['waitingQueueItems', 'byQueue', action.queueKey], List());
        var _iterator = _createForOfIteratorHelper(action.queueCalls),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var queueCall = _step.value;
            byKeyMap = byKeyMap.set(queueCall.key, fromJS(queueCall));
            byQueueList = byQueueList.push(queueCall.key);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return state.setIn(['waitingQueueItems', 'byKey'], byKeyMap).setIn(['waitingQueueItems', 'byQueue', action.queueKey], byQueueList);
      }
    case Actions.RESULT_TOP_WAITING_QUEUE_ITEM_ADD:
      {
        var _queueCall = fromJS(action.queueCall);
        var position = action.position;
        return state.setIn(['waitingQueueItems', 'byKey', action.queueCallKey], _queueCall).updateIn(['waitingQueueItems', 'byQueue', action.queueKey], List(), function (list) {
          return list.insert(position - 1, action.queueCallKey);
        });
      }
    case Actions.RESULT_TOP_WAITING_QUEUE_ITEM_REMOVE:
      {
        return state.withMutations(function (map) {
          map.deleteIn(['waitingQueueItems', 'byKey', action.queueCallKey]).updateIn(['waitingQueueItems', 'byQueue', action.queueKey], List(), function (list) {
            var index = list.findIndex(function (queueCallKey) {
              return queueCallKey === action.queueCallKey;
            });
            return index !== -1 ? list["delete"](index) : list;
          });
        });
      }
    case Actions.SET_TOP_QUEUE_CALL:
      {
        return state.updateIn(['topActiveQueueCalls', 'byQueue', action.queue], OrderedMap(), function (map) {
          return map.set(action.channelID, action.state);
        });
      }
    // Once an agent picks a queue call up it carries on as an ordinary channel,
    // and that channel leaving the queue's ongoing calls is the only thing left
    // to tell us the call is over. Neither the channel nor its hangup carries
    // the queue call's locutus session or when it entered the queue, so we
    // remember both against the channel while it is still there. Keyed per queue
    // since a call transferred between queues produces one record per queue.

    case Actions.SET_QUEUE_CALL_FOR_CHANNEL:
      {
        var path = ['queueCallsByChannel', action.channelID, action.queueKey];

        // The channel repeats its queue events on hold, unhold and
        // transfer. Keep the call record once it is known: a later event
        // can only match on the caller's number again, which by then can
        // reach a different caller who waits with the same number.
        if (state.getIn([].concat(path, ['callRecordKey']))) return state;
        return state.setIn(path, Map({
          callRecordKey: action.callRecordKey,
          queueJoinTime: action.queueJoinTime
        }));
      }
    case Actions.RESULT_TOP_HANGUP_CHANNEL:
      {
        //We try to remove the UniqueID from all queues due to a problem that occurrs when a queue call is transferred to another queue
        //and then picked, then the UniqueID will be present for both queues and we need to remove both of them. This is because top first sends
        //a QueueCallInfo event with the first queue's info before it sends one with the seconds queue's infor when the call is picked.
        //This feels wrong and should probably be fixed so that the first event is not sent.
        return state.updateIn(['topActiveQueueCalls', 'byQueue'], OrderedMap(), function (queues) {
          return queues.map(function (map) {
            return map["delete"](action.data.UniqueID);
          });
        }).deleteIn(['queueCallsByChannel', action.data.UniqueID]);
      }
    case Actions.RESULT_ACTIVE_OMNI_ERRANDS:
      {
        var updatedErrands = listToMap(fromJS(action.data), function (e) {
          return e.get('callId');
        });
        return state.setIn(['activeOmniErrands', 'byQueue', action.queue], updatedErrands);
      }
    case Actions.CLEAR_TOP_QUEUE_CALLS:
      {
        return state["delete"]('topActiveQueueCalls')["delete"]('queueCallsByChannel').deleteIn(['waitingQueueItems', 'byKey']).deleteIn(['waitingQueueItems', 'byQueue']);
      }
    case Actions.RESULT_QUEUE_PROFILE:
      {
        return state.updateIn(['queues', action.key, 'activeProfile'], function () {
          return fromJS(action.data);
        });
      }
    case Actions.RESULT_QUEUE_CALENDAR:
      {
        return state.updateIn(['queues', action.key, 'calendar'], function () {
          return fromJS(action.data);
        });
      }
    case Actions.RESULT_QUEUE_OPENING_HOURS:
      {
        return state.setIn(['queues', action.key, 'calendar', 'openingHours'], fromJS(action.data));
      }
    case Actions.RESULT_QUEUE_STAT_SUMMARY:
      {
        return state.mergeIn(['queues', action.key, 'statistics', 'queueStats'], fromJS(action.data).get('queueStats'));
      }
    case Actions.RESULT_QUEUES:
      {
        var newQueues = fromJS(action.data);
        var mapped = listToMap(newQueues, function (item) {
          return item.get('key');
        });
        var ownExtensionKey = action.ownExtensionKey;

        // Extract queueMembers from queues and remove them from the queue objects
        var mappedWithoutQueueMembers = mapped.map(function (queue) {
          return queue["delete"]('queueMembers');
        });
        return state.update('queues', function () {
          var prevQueues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
          return prevQueues.filter(keyIn.apply(void 0, _toConsumableArray(mapped.keys()))).mergeDeep(mappedWithoutQueueMembers);
        }).update('queueMembers', function () {
          var prevQueueMembers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
          /*
          In order to show the correct list of queuemembers when the list is modified from some
          other client we need to explicitly remove the queuemembers that are in the state
          but not in the updated queue data, since mergeDeep will not do that for us.
          And since the queueMembers in the updated queue data (which is from getSimpleQueues)
          do not contain contacts we cannot simply replace the old queuemembers with the new ones
          becaues that would remove existing contacts, causing the behavior in WEB-8273.
          */
          var updatedQueueMembers = prevQueueMembers;

          // Remove queueMembers for queues that no longer exist
          updatedQueueMembers = updatedQueueMembers.filter(function (_members, queueKey) {
            return mapped.has(queueKey);
          });

          // For each queue, filter out members that are no longer in the updated data
          // and add new members that weren't there before
          mapped.forEach(function (updatedQueue, queueKey) {
            var updatedQueueMembersFromAction = updatedQueue.get('queueMembers', List());
            var updatedQueueMemberKeys = updatedQueueMembersFromAction.map(function (queueMember) {
              return queueMember.get('key');
            });
            var prevQueueMembersList = updatedQueueMembers.get(queueKey, List());
            if (prevQueueMembersList.size > 0) {
              // Merge updated data into existing members (preserves fields
              // like contact that getSimpleQueues doesn't return, while
              // updating fields like loggedIn that it does return)
              var mergedQueueMembers = prevQueueMembersList.filter(function (queueMember) {
                return updatedQueueMemberKeys.includes(queueMember.get('key'));
              }).map(function (prevMember) {
                var updatedMember = updatedQueueMembersFromAction.find(function (m) {
                  return m.get('key') === prevMember.get('key');
                });
                return updatedMember ? prevMember.mergeDeep(updatedMember) : prevMember;
              });

              // Add new members that weren't in the previous list
              var existingMemberKeys = mergedQueueMembers.map(function (queueMember) {
                return queueMember.get('key');
              });
              var newMembers = updatedQueueMembersFromAction.filter(function (queueMember) {
                return !existingMemberKeys.includes(queueMember.get('key'));
              });
              updatedQueueMembers = updatedQueueMembers.set(queueKey, mergedQueueMembers.concat(newMembers));
            } else {
              // If there are no previous queueMembers, set the new ones
              updatedQueueMembers = updatedQueueMembers.set(queueKey, updatedQueueMembersFromAction);
            }
          });
          return updatedQueueMembers;
        }).update('sortingData', function () {
          var sortingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
          return sortingData.update('queues', function () {
            var queues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
            // First filter out queues that no longer exist
            var filteredQueues = queues.filter(function (_queue, queueKey) {
              return mapped.has(queueKey);
            });
            // Then update/add queues from the action data
            return mapped.reduce(function (acc, item) {
              var ownExtensionIsMember = item.get('queueMembers', List()).some(function (queueMember) {
                return ownExtensionKey && queueMember.get('extensionKey') === ownExtensionKey;
              });
              return acc.set(item.get('key'), Map({
                description: item.get('description'),
                key: item.get('key'),
                number: item.get('number'),
                // Flattened off the queue's own contact -- not its
                // members' -- so the PBX list can search on it. The
                // projection is deliberately light, so it takes the
                // one field rather than the whole contact. A response
                // without a contact (the reconnect refresh fetches
                // without one) keeps the keywords already held; a
                // contact without keywords means they were cleared,
                // since the API omits null fields. (AC-1943)
                keywords: item.has('contact') ? item.getIn(['contact', 'keywords']) : acc.getIn([item.get('key'), 'keywords']),
                ownExtensionIsMember: ownExtensionIsMember
              }));
            }, filteredQueues);
          });
        });
      }
    case Actions.RESULT_GET_VOICEMAIL_ACTIONS:
      {
        var voiceMessageActionList = fromJS(action.voiceMessageActions);
        if (voiceMessageActionList.isEmpty()) {
          return state.deleteIn(['voicemails', action.voicemailKey, 'voiceMessageActions', action.voiceMessageKey]);
        } else {
          return state.setIn(['voicemails', action.voicemailKey, 'voiceMessageActions', action.voiceMessageKey], voiceMessageActionList);
        }
      }
    case Actions.RESULT_CREATE_VOICEMAIL_ACTION:
      {
        return state.updateIn(['voicemails', action.voicemailKey, 'voiceMessageActions', action.voiceMessageKey], List(), function (actionList) {
          return actionList.push(fromJS(action.voiceMessageAction));
        });
      }
    case Actions.RESULT_DELETE_VOICEMAIL_ACTION:
      {
        var updatedVoiceMessageActions = state.getIn(['voicemails', action.voicemailkey, 'voiceMessageActions', action.voiceMessageKey], List()).update(function (actionList) {
          var actionIndex = actionList.find(function (action) {
            return action.get('key') === action.callActionKey;
          });
          return actionList["delete"](actionIndex);
        });
        if (updatedVoiceMessageActions.isEmpty()) {
          return state.deleteIn(['voicemails', action.voicemailKey, 'voiceMessageActions', action.voiceMessageKey]);
        } else {
          return state.setIn(['voicemails', action.voicemailKey, 'voiceMessageActions', action.voiceMessageKey], updatedVoiceMessageActions);
        }
      }
    case Actions.RESULT_QUEUE_MEMBER_UPDATE:
      {
        var indexOfMember = state.getIn(['queueMembers', action.queueKey], List()).findIndex(function (member) {
          return member.get('key') === action.memberKey;
        });
        if (indexOfMember === -1) {
          return state;
        }
        var updatedQueueWaves = state.getIn(['queues', action.queueKey, 'queueWaves'], List()).map(function (queueWave) {
          return queueWave.set('queueWaveMappingDTOs', queueWave.get('queueWaveMappingDTOs').map(function (queueWaveMapping) {
            var queueMember = queueWaveMapping.get('queueMember');
            return queueWaveMapping.set('queueMember', queueMember.get('key') === action.memberKey ? queueMember.mergeDeep(fromJS(action.data)) : queueMember);
          }));
        });
        return state.updateIn(['queueMembers', action.queueKey, indexOfMember], Map(), function (prev) {
          return prev.mergeDeep(fromJS(action.data));
        }).setIn(['queues', action.queueKey, 'queueWaves'], updatedQueueWaves);
      }
    case Actions.RESULT_ADD_QUEUE_MEMBERS:
      {
        var _ownExtensionKey = action.ownExtensionKey;
        var allQueueMembers = fromJS(action.data);
        return state.setIn(['queueMembers', action.queueKey], allQueueMembers).updateIn(['sortingData', 'queues', action.queueKey, 'ownExtensionIsMember'], function () {
          return !!allQueueMembers.find(function (member) {
            return _ownExtensionKey && member.get('extensionKey') === _ownExtensionKey;
          });
        });
      }
    case Actions.RESULT_ADD_QUEUE_WAVE_MAPPINGS:
      {
        var existingQueueMembers = state.getIn(['queueMembers', action.queueKey], List());
        var existingQueueMemberKeys = existingQueueMembers.map(function (queueMember) {
          return queueMember.get('key');
        });
        var queueWaveMappings = fromJS(action.data);
        var queueMembersFromMappings = queueWaveMappings.map(function (queueWaveMapping) {
          return queueWaveMapping.get('queueMember');
        });
        var newQueueMembers = queueMembersFromMappings.filter(function (queueMember) {
          return !existingQueueMemberKeys.contains(queueMember.get('key'));
        });
        var updatedQueueMembers = existingQueueMembers.concat(newQueueMembers);
        var indexOfWave = state.getIn(['queues', action.queueKey, 'queueWaves']).findIndex(function (queueWave) {
          return queueWave.get('key') === action.queueWaveKey;
        });
        return state.setIn(['queues', action.queueKey, 'queueWaves', indexOfWave, 'queueWaveMappingDTOs'], queueWaveMappings).setIn(['queueMembers', action.queueKey], updatedQueueMembers);
      }
    case Actions.RESULT_REMOVE_QUEUE_MEMBERS:
      {
        var _ownExtensionKey2 = action.ownExtensionKey;
        var queueMembersWithoutRemoved = fromJS(action.data); // This is the list of queue members that are still members after the removal
        return state.setIn(['queueMembers', action.queueKey], queueMembersWithoutRemoved).updateIn(['sortingData', 'queues', action.queueKey, 'ownExtensionIsMember'], function () {
          return !!queueMembersWithoutRemoved.find(function (member) {
            return _ownExtensionKey2 && member.get('extensionKey') === _ownExtensionKey2;
          });
        });
      }
    case Actions.RESULT_REMOVE_QUEUE_WAVE_MAPPING:
      {
        var queueWaves = fromJS(action.data);
        var queueMemberKeys = queueWaves.flatMap(function (queueWave) {
          return queueWave.get('queueWaveMappingDTOs').map(function (queueWaveMapping) {
            return queueWaveMapping.get('queueMember').get('key');
          });
        });
        var _updatedQueueMembers = state.getIn(['queueMembers', action.queueKey]).filter(function (queueMember) {
          return queueMemberKeys.contains(queueMember.get('key'));
        });
        return state.setIn(['queues', action.queueKey, 'queueWaves'], queueWaves).setIn(['queueMembers', action.queueKey], _updatedQueueMembers);
      }
    case Actions.RESULT_ALLOWED_QUEUE_MEMBERS:
      {
        return state.setIn(['queues', action.key, 'allowedQueueMembers'], fromJS(action.data));
      }
    case Actions.RESULT_REFER:
      {
        var referDTO = fromJS(action.data);
        return state.updateIn(['refers', action.key], Map(), function (prev) {
          return prev.mergeDeep(referDTO);
        });
      }
    case Actions.RESULT_REFER_PROFILE:
      {
        return state.updateIn(['refers', action.key, 'activeProfile'], function () {
          return fromJS(action.data);
        });
      }
    case Actions.RESULT_REFER_PROFILES:
      {
        return state.updateIn(['refers', action.key, 'profiles'], function () {
          return fromJS(action.data);
        });
      }
    case Actions.RESULT_REFER_CALENDAR:
      {
        return state.updateIn(['refers', action.key, 'calendar'], function () {
          return fromJS(action.data);
        });
      }
    case Actions.RESULT_REFER_OPENING_HOURS:
      {
        return state.setIn(['refers', action.key, 'calendar', 'openingHours'], fromJS(action.data));
      }
    case Actions.RESULT_REFERS:
      {
        var newRefers = fromJS(action.data);
        var _mapped = listToMap(newRefers, function (item) {
          return item.get('key');
        });
        var updatedState = state.update('refers', function () {
          var prevRefers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
          return prevRefers.filter(keyIn.apply(void 0, _toConsumableArray(_mapped.keys()))).mergeDeep(_mapped);
        });
        return updatedState;
      }
    case Actions.RESULT_SHARED_VOICEMAILS:
      {
        var voicemailsReceived = fromJS(action.data);
        var mappedVoicemails = listToMap(voicemailsReceived, function (item) {
          return item.get('key');
        });
        var updatedMappedVoicemails = mappedVoicemails.map(function (voicemail) {
          var voiceMessages = voicemail.get('voiceMessages', Map());
          var mappedVoiceMessages = listToMap(voiceMessages, function (item) {
            return item.get('uniqueId');
          });
          var orderedMappedVoiceMessages = getVoiceMessagesSortedByReceivedDate(mappedVoiceMessages);
          return voicemail.set('voiceMessages', orderedMappedVoiceMessages);
        });

        /*
         * Some voicemail properties are not always included in the API response.
         * Therefore, we update and merge instead of doing a set, so that we don't lose any of the voicemail data that
         * is present in the state but not in the API response...
         **/
        var stateMerged = state.update('voicemails', function () {
          var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
          return prev.mergeDeep(updatedMappedVoicemails);
        });

        /*
         * ...however, a voicemail's voice messages should be overwritten from the API response.
         * The reason is that voice message(s) present in our store but not in the API response are messages that have probably been deleted by a colleague,
         * and we don't want to present non-existing voice messages.
         **/
        var stateWithUpdatedVoiceMessages = stateMerged.update('voicemails', function (voicemails) {
          return voicemails.map(function (voicemail, key) {
            return voicemail.set('voiceMessages', updatedMappedVoicemails.getIn([key, 'voiceMessages']));
          });
        });

        // If the voicemessages/state hasn't changed we want to make sure we return the same state to avoid rerender.
        return state.get('voicemails', Map()).equals(stateWithUpdatedVoiceMessages.get('voicemails', Map())) ? state : stateWithUpdatedVoiceMessages;
      }
    case Actions.RESULT_SHARED_VOICEMAIL:
      {
        var immutableData = fromJS(action.data);
        var voiceMessages = immutableData.get('voiceMessages', Map());
        var mappedVoiceMessages = listToMap(voiceMessages, function (item) {
          return item.get('uniqueId');
        });
        var orderedMappedVoiceMessages = getVoiceMessagesSortedByReceivedDate(mappedVoiceMessages);

        /*
         * Some voicemail properties are not always included in the API response.
         * Therefore, we update and merge instead of doing a set, so that we don't lose any of the voicemail data that
         * is present in the state but not in the API response.
         * However, the voicemail's voice messages should be overwritten from the API response.
         * The reason is that voice message(s) present in our store but not in the API response are messages that have probably been deleted by a colleague,
         * and we don't want to present non-existing voice messages.
         **/
        return state.updateIn(['voicemails', action.key], Map(), function (voicemail) {
          return voicemail.mergeDeep(immutableData);
        }).setIn(['voicemails', action.key, 'voiceMessages'], orderedMappedVoiceMessages);
      }
    case Actions.RESULT_SHARED_VOICEMESSAGE_DELETE:
      {
        return state.updateIn(['voicemails', action.key, 'voiceMessages'], function (messages) {
          return messages.filter(function (m) {
            return m.get('uniqueId') !== action.data.uniqueId;
          });
        });
      }
    case Actions.RESULT_SHARED_VOICEMESSAGES_DELETE_ALL:
      {
        return state.setIn(['voicemails', action.key, 'voiceMessages'], List());
      }
    case Actions.SET_SHARED_VOICEMESSAGE_READ:
      {
        return state.setIn(['voicemails', action.voicemailKey, 'voiceMessages', action.voiceMessageUniqueID, 'voiceMessageState'], 'read');
      }
    case Actions.RESULT_CONFERENCE:
      {
        var indexOfConference = state.get('conferences').findIndex(function (conference) {
          return conference.get('key') === action.key;
        });
        return state.setIn(['conferences', indexOfConference], fromJS(action.data));
      }
    case Actions.RESULT_CONFERENCES:
      {
        return state.update('conferences', function () {
          return fromJS(action.data);
        });
      }
    case Actions.RESULT_REFER_UPDATE_CALENDAR_EVENT:
      {
        return state.updateIn(['refers', action.entityKey, 'calendar', 'events'], List(), function (events) {
          return events.set(events.findIndex(function (e) {
            return e.get('key') === action.originalCalendarEventKey;
          }), fromJS(action.data));
        });
      }
    case Actions.RESULT_REFER_REMOVE_CALENDAR_EVENT:
      {
        return state.updateIn(['refers', action.entityKey, 'calendar', 'events'], function (events) {
          return events.filter(function (e) {
            return e.get('key') !== action.data.key;
          });
        });
      }
    case Actions.RESULT_REFER_ADD_CALENDAR_EVENT:
      {
        return state.updateIn(['refers', action.entityKey, 'calendar', 'events'], function (events) {
          return events.push(fromJS(action.data));
        });
      }
    case Actions.RESULT_QUEUE_UPDATE_CALENDAR_EVENT:
      {
        return state.updateIn(['queues', action.entityKey, 'calendar', 'events'], List(), function (events) {
          return events.set(events.findIndex(function (e) {
            return e.get('key') === action.originalCalendarEventKey;
          }), fromJS(action.data));
        });
      }
    case Actions.RESULT_QUEUE_REMOVE_CALENDAR_EVENT:
      {
        return state.updateIn(['queues', action.entityKey, 'calendar', 'events'], function (events) {
          return events.filter(function (e) {
            return e.get('key') !== action.data.key;
          });
        });
      }
    case Actions.RESULT_QUEUE_ADD_CALENDAR_EVENT:
      {
        return state.updateIn(['queues', action.entityKey, 'calendar', 'events'], function (events) {
          return events.push(fromJS(action.data));
        });
      }
    case Actions.RESULT_SHARED_EXTENSION:
      {
        return state.update('connections', Map(), function () {
          return fromJS(action.data);
        });
      }
    case Actions.RESULT_QUEUE_PROFILE_UPDATE:
      {
        return state.updateIn(['queues', action.entityKey, 'profiles'], function (profiles) {
          return profiles.set(profiles.findIndex(function (p) {
            return p.get('key') === action.profileKey;
          }), fromJS(action.data));
        });
      }
    default:
      {
        return state;
      }
  }
};
export default pbxReducer;